/**
 * A blob as a `data:` URL. This is how a logo is shown, never as a `blob:` URL
 * (issue #20): a `blob:` URL belongs to the origin of the page that made it, so
 * an SVG opened from it in a tab would run its scripts there, with the session
 * token in reach. A `data:` URL has an opaque origin and browsers refuse to
 * navigate to it from the top level; through `<img>` it renders as any image.
 */
export function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') resolve(reader.result);
      else reject(new Error('The image could not be read.'));
    };
    reader.onerror = () => reject(reader.error ?? new Error('The image could not be read.'));
    reader.readAsDataURL(blob);
  });
}

/** A blob's text (UTF-8), through `FileReader` as `blobToDataUrl` is. */
export function blobToText(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') resolve(reader.result);
      else reject(new Error('The file could not be read.'));
    };
    reader.onerror = () => reject(reader.error ?? new Error('The file could not be read.'));
    reader.readAsText(blob);
  });
}
